import {Component} from 'react';
import "./GameViews/gameViews.css";
import "./GameViews/gameViewMedia.css";

class GameChoicePictures extends Component {
        constructor(props) {
        super(props); 
        this.state={
            
        };  
    }

     
    render() { 
                                               
    return <>
        
        <div className="first-column">
            <div className="mt-5">
                <img className="left-side-img" src={this.props.pictureInfo.jobImg} alt={"jobImg"}/>
                <p className="text-for-left-side-img">{this.props.pictureInfo.jobName}</p>
            </div>
            <div className="mt-5">
                <img className="left-side-img" src={this.props.pictureInfo.homeImg} alt={"homeImg"}/>
                <p className="text-for-left-side-img">{this.props.pictureInfo.homeName}</p>
            </div>
            <div className="mt-5">
                <img className="left-side-img-car " src={this.props.pictureInfo.carImg} alt={"carImg"}/>
                <p className="text-for-left-side-img">{this.props.pictureInfo.carName}</p>
            </div>
          </div>
    </>
  }


}
 
export default GameChoicePictures;